import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useAppStore } from "@/global/store";
import { selectPackageSelected } from "@/global/store/data/purchaseSeats/packages";

export function useMinEventCount() {
  const { purchaseSeatConfigs, packageConfigs } = useTeamConfig();
  const { minGameSelectionCount } = purchaseSeatConfigs;
  const { isPackageEnabled } = packageConfigs;
  const pkgSelected = useAppStore(selectPackageSelected);

  const result = { minGameSelectionCount };
  if (
    isPackageEnabled &&
    !!pkgSelected &&
    pkgSelected?.minEventSelectionCount
  ) {
    result.minGameSelectionCount = pkgSelected?.minEventSelectionCount;
  }

  return result;
}
